import { User, Channel, Chat, Wellness, Encryption } from '../models';
import { HttpHeaders, HttpParams } from '@angular/common/http';
import { ViewChatRecipient } from '../async-services/http/versioned/interfaces/chat.interface';

export enum LoadingState {
  INIT,
  LOADING,
  LOADED,
}

export interface HttpOptions {
  headers?:
    | HttpHeaders
    | {
        [header: string]: string | string[];
      };
  observe?: 'body';
  params?:
    | HttpParams
    | null
    | {
        [param: string]: string | string[];
      };
  reportProgress?: boolean;
  responseType?: 'json';
  withCredentials?: boolean;
  'x-refresh'?: string;
}

export interface Response<T = any> {
  message?: string;
  payload?: T;
}

export type EncryptedResponse = Response<Encryption.SecuredPayload>;

export interface GetCurrentLoggedInUserInfoSuccess extends Response {
  payload: User.User;
}

export interface GetNotificationPreferencesSuccess extends Response {
  payload: User.NotificationPreferences;
}

export interface GetInboxChannelSuccess extends Response {
  payload: {
    channel: string;
  };
}
export interface GetChannelsUser {
  userId: string;
  userType: 'MHTv2' | 'HE';
  lastName: string;
  firstName: string;
  title: string;
}

export interface GetChannelsChannel {
  type: Channel.Type;
  name: string;
  latestMsg: {
    user: GetChannelsUser;
    msg: string;
    dateTime: string;
  };
  userHasUnreadMsgs: boolean;
  users: GetChannelsUser[];
}

export interface GetChannelsSuccess extends Response {
  payload: {
    channels: GetChannelsChannel[];
    pageNumberCurrent: number;
    pageNumberMax: number;
  };
}

export interface ChatContactsSuccess extends Response {
  responseMessage: string;
  payload: {
    availablePeople: Chat.Contact[];
  };
}

export interface ChatChannelSuccess extends Response {
  responseMessage: string;
  payload: {
    users?: ViewChatRecipient[];
    channel: string;
    messages?: Chat.Message[];
    messageIdMin: string;
    messageIdMax: string;
  };
}

export interface ArchiveChannelBody {
  channel: string;
}

export interface ArchiveChannelSuccess extends Response {
  payload: {
    channelArchive: Channel.Channel;
  };
}

export interface GetPublicEncryptionKeySuccess extends Response {
  payload: {
    key_id: string;
    public_key: string;
  };
}

export type GetWellnessHotelsSuccess = Response<{
  hotels: Wellness.Hotel[];
}>;

export interface GetWellnessCompletionReportBody {
  entId: string;
  date: string;
}

export type GetWellnessCompletionReportSuccess = Response<{
  surveys: Wellness.Survey[];
  completionRate: number;
}>;

export type GetWellnessRisksSuccess = Response<{
  risks: Wellness.Risk[];
}>;

export type SecureUrlResponse = Response<{
  url: string;
}>;
